import React, {FC} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import classNames from 'classnames';
import {contactQuery} from 'graphql/mutations';
import {listQuery} from 'graphql/queries';
import {ContactData, WaitListData} from 'graphql/types';

import {ContactForm} from './_ContactForm';
import {viewQuery} from './queries';
import {Contact} from './types';

import * as styles from './styles.module.scss';

export const useWaitListData = (path: string) => {
	const {data} = useQuery<WaitListData>(listQuery, {variables: {path}});
	const [addContact] = useMutation<ContactData>(contactQuery);
	const [addView] = useMutation<ContactData>(viewQuery);

	return {
		data,

		onSubmit: async (contact: Contact) => {
			return await addContact({
				variables: {
					...contact,
					path,
				},
			});
		},

		onView: async (id: string) => {
			return await addView({
				variables: {
					uuid: `${id}@local.uuid`,
					path,
				},
			});
		}
	};
};

export interface IWaitListProps {
	className?: string;
	path: string;
}

export const WaitListInner: FC<IWaitListProps> = ({className, path}) => {
	return (
		<div className={classNames(styles.waitList, className)}>
			<ContactForm path={path} />
		</div>
	);
};

const WaitList: FC<IWaitListProps> = (props) => {
	return (
		<div className={styles.container}>
			<WaitListInner {...props} />
		</div>
	);
};

export default WaitList;
